<template>
  <div>
    <div class="breadcrumb-area pos-relative w-100">
      <h1>{{ isUpdate ? 'Cập nhật công việc' : 'Thêm mới công việc' }}</h1>
      <div class="float-right">
        <button
          type="button"
          class="font-medium f12 btn btn-outline-secondary m-r-10"
          @click="$router.push('/customer-support/task')"
        >
          <b-icon icon="arrow-left" aria-hidden="true" />
          Quay lại
        </button>
        <button
          type="submit"
          class="font-medium f12 btn btn-outline-primary m-r-10"
          @click="submitForm"
          :disabled="isLoading || (!canEdit && !canEditTaskName)"
        >
          <b-icon icon="check-lg" aria-hidden="true" />
          {{ isUpdate ? 'Cập nhật' : 'Thêm mới' }}
        </button>
      </div>
      <hr />
    </div>

    <b-container fluid>
      <b-row class="gx-1">
        <b-col cols="12" md="4">
          <b-card class="card-section">
            <div class="header-section">Thông tin công việc</div>
            <div class="form-item">
              <div class="form-label require">Nhóm công việc</div>
              <div class="form-input">
                <Select2
                  v-model="type"
                  :options="typeOptions"
                  placeholder="Chọn nhóm công việc"
                  @change="loadDataTask($event)"
                  :disabled="isUpdate"
                />
                <div class="error">{{ error.type }}</div>
              </div>
            </div>

            <div class="form-item">
              <div class="form-label require">Tên công việc</div>
              <div class="form-input">
                <Select2
                  v-model="purposes"
                  :options="purposesOptions"
                  :placeholder="isLoadingPurposes ? 'Loading...' : 'Chọn tên công việc'"
                  @change="changeCode"
                  :disabled="!type || !canEditTaskName || !purposesOptions.length"
                />
                <div class="error">{{ error.purposes }}</div>
              </div>
            </div>
            <div class="form-item">
              <div class="form-label require">Tiểu mục công việc</div>
              <div class="form-input">
                <Select2
                  v-model="subCategoryCode"
                  :options="subCategorypOtions"
                  :placeholder="!subCategoryCodeLoading ? 'Chọn tiểu mục' : ' Loading...'"
                  :disabled="
                    !purposes || subCategoryCodeLoading || subCategorypOtions?.length === 0
                  "
                >
                </Select2>

                <div class="error">{{ error.subCategoryCode }}</div>
              </div>
            </div>

            <div class="form-item">
              <div class="form-label require">Đối tượng</div>
              <div class="form-input">
                <Select2
                  v-model="applyFor"
                  :options="subjectOptions"
                  placeholder="Chọn đối tượng"
                  :disabled="isUpdate"
                  @change="onChangeSubject($event)"
                />
                <div class="error">{{ error.applyFor }}</div>
              </div>
            </div>
            <div class="form-item">
              <div class="form-label require">Hình thức chăm sóc</div>
              <div class="form-input">
                <Select2
                  v-model="methodCare"
                  :options="methodCareOptions"
                  placeholder="Chọn hình thức chăm sóc"
                  :disabled="isLoading || isUpdate"
                />
                <div class="error">{{ error.methodCare }}</div>
              </div>
            </div>
          </b-card>
        </b-col>

        <b-col cols="12" md="5">
          <b-card class="card-section">
            <div class="header-section d-flex justify-content-between">
              <div>Thông tin chung</div>
              <div>
                <button
                  variant="danger"
                  class="btn btn-sm btn-outline-danger mr-2"
                  v-show="assignType !== 'NORMAL' && hasShowAssignTaskButton"
                  @click="RemoveAssignTask"
                >
                  Huỷ giao việc
                </button>
                <button
                  variant="primary"
                  class="btn btn-sm btn-outline-primary"
                  v-show="hasShowAssignTaskButton"
                  @click="showPopupFindStaff"
                >
                  Giao việc
                </button>
              </div>
            </div>
            <div class="form-item" v-show="[EnumTaskApplyFor.MO].includes(applyFor)">
              <div class="form-label require">Merchant owner</div>
              <div class="form-input">
                <Select2
                  v-model="merchantOwnerId"
                  :disabled="!applyFor || isUpdate"
                  :options="merchantOwnerOptions"
                  placeholder="Tìm kiếm merchant account"
                  :settings="merchantOwnerSettings"
                  @change="onChangeMerchantOwner($event)"
                />
                <div class="error">{{ error.merchantOwnerId }}</div>
              </div>
            </div>
            <div
              class="form-item"
              v-show="[EnumTaskApplyFor.MA, EnumTaskApplyFor.STORE].includes(applyFor)"
            >
              <div class="form-label require">Merchant</div>
              <div class="form-input">
                <Select2
                  v-model="customerId"
                  :disabled="!applyFor || isUpdate"
                  :options="merchantOptions"
                  placeholder="Tìm kiếm merchant account"
                  :settings="merchantSettings"
                  @change="onChangeMerchant($event)"
                />
                <div class="error">{{ error.customerId }}</div>
              </div>
            </div>
            <div class="form-item" v-show="[EnumTaskApplyFor.STORE].includes(applyFor)">
              <div class="form-label require">Cửa hàng</div>
              <div class="form-input">
                <Select2
                  v-model="storeId"
                  :options="storeOptions"
                  :disabled="!customerId || isUpdate || isLoadingStore || !storeOptions.length"
                  :placeholder="isLoadingStore ? 'Loading...' : 'Chọn cửa hàng'"
                  @change="onChangeStore($event)"
                />
                <div class="error">
                  {{
                    !isLoadingStore && !!customerId && storeOptions.length === 0
                      ? 'Không có cửa hàng'
                      : error.storeId
                  }}
                </div>
              </div>
            </div>
            <div class="form-item">
              <div class="form-label require">Người xử lý</div>
              <div class="form-input">
                <Select2
                  v-model="assigneeId"
                  :options="listStaffOptions"
                  :placeholder="isLoadingStaff ? 'Loading...' : 'Chọn người xử lý'"
                  :disabled="
                    !staffOptions.length || !canEditHandler || this.assignType !== 'NORMAL'
                  "
                />
                <div class="error">
                  {{
                    !isLoadingStaff &&
                    listStaffOptions.length === 0 &&
                    (applyFor === EnumTaskApplyFor.MO
                      ? !!merchantOwnerId
                      : applyFor === EnumTaskApplyFor.MA
                        ? !!customerId
                        : !!storeId)
                      ? 'Không có nhân viên chăm sóc'
                      : error.assigneeId
                  }}
                </div>
              </div>
            </div>
          </b-card>

          <b-card class="card-section mt-3">
            <div class="header-section">Thông tin khác</div>
            <div class="form-item">
              <div class="form-label">Thời gian yêu cầu thực hiện</div>
              <div class="form-input">
                <!-- <InputRange v-model="dateRange" :disabled="!canEdit" /> -->
                <InputRange
                  v-model="dateRange"
                  :disabled="!canEdit"
                  :popover="{
                    placement: 'bottom-start',
                    visibility: 'click',
                    positionFixed: true,
                  }"
                />
                <div class="error">{{ error.dateRange }}</div>
              </div>
            </div>
            <div class="form-item">
              <div class="form-label">Lý do thực hiện công việc</div>
              <div class="form-input">
                <b-form-input v-model="note" placeholder="Lý do" :disabled="!canEdit" />
              </div>
            </div>
            <div class="form-item">
              <div class="form-label">Ghi chú</div>
              <div class="form-input">
                <b-form-input v-model="description" placeholder="Ghi chú" :disabled="!canEdit" />
              </div>
            </div>
          </b-card>
        </b-col>
      </b-row>
    </b-container>
    <PopupFindStaff :isUpdate="isUpdate" ref="popupFindStaffRef" @submit="onChangeStaff" />
    <VueLoadingOverlay :active.sync="isLoading" :is-full-page="true" />
    <!-- </Form> -->
  </div>
</template>

<script>
  import { mapGetters } from 'vuex'
  import { StaffService } from '@/services/staff.service'
  import { showMess } from '@/config/utils'
  import {
    WorkGroupList,
    WorkTaskList,
    TaskAdd,
    TaskDetail,
    TaskUpdate,
  } from '@/services/customer-support/task'
  import {
    List as ListMo,
    // GetList as GetMoByIds,
  } from '@/services/customer-support/merchant-owner'
  import { Search as ListMa } from '@/services/customer-support/account'
  import { List as ListStore } from '@/services/customer-support/store'
  import { GetAssignment } from '@/services/customer-support/store-staff'
  import InputRange from '@/components/InputRange.vue'
  import {
    EnumTaskStatus,
    EnumQuestionType,
    TaskStatus,
    TaskResultStatus,
    EnumTaskApplyFor,
    TaskApplyFor,
    FlowChangeStatus,
    EnumTaskMethodCare,
    TaskMethodCare,
  } from '@/constant/customerSupport'

  // import UploadMultipleCSKh from '@/components/cskh/UploadMultiple.vue'

  import PopupFindStaff from './components/PopupFindStaff.vue'

  import { CalendarAfsService } from '@/services/calendar-afs.service'

  const currentUser = JSON.parse(localStorage.getItem('userData'))

  const NEW_ID = 'new'
  const typeSale = [
    'SALE',
    'ACCOUNT_MANAGER',
    'AFTER_SALE',
    'TELESALE',
    'TRAINER',
    'COOPERATOR',
    'AFTER_SALE_OFFLINE',
  ]
  export default {
    name: 'CreateTask',
    components: {
      // SupportInfo,
      // DateRangePicker,
      InputRange,
      // UploadMultiple,
      // UploadMultipleCSKh
      // Form,
      // Field,
      PopupFindStaff,
    },
    data() {
      return {
        isLoading: false,
        hasSubmit: false,
        EnumTaskApplyFor,
        EnumTaskStatus,
        EnumQuestionType,
        EnumTaskMethodCare,
        id: '',
        status: EnumTaskStatus.NEW,
        // newStatus: EnumTaskStatus.NEW,
        // statusOptions: TaskStatus.map(s => {
        //   return {
        //     ...s,
        //     disabled: !FlowChangeStatus[this.status]
        //   }
        // }),

        result: '',
        newResult: '',
        resultOptions: TaskResultStatus,
        memorizeStaff: null,
        afterSaleNote: '',
        currentUser,

        type: '',
        typeOptions: [],

        methodCare: EnumTaskMethodCare.OFFLINE,
        methodCareOptions: TaskMethodCare,

        subCategoryCode: '',
        subCategorypOtions: [],
        subCategoryCodeLoading: false,
        purposesCode: '',

        purposes: '',
        isLoadingPurposes: false,
        purposesOptions: [],

        applyFor: '',
        subjectOptions: TaskApplyFor,

        merchantOwnerId: '',
        merchantOwnerOptions: [],

        customerId: '',
        merchantOptions: [],

        storeId: '',
        assignType: 'NORMAL',
        isLoadingStore: false,
        storeOptions: [],

        assigneeId: currentUser?.userId, // currentUser.userId,
        isLoadingStaff: false,
        staffOptions: [],
        supportInfos: [],
        isLoadingSupportInfos: false,

        note: '',
        description: '',
        // startDate: '',
        // endDate: '',
        // listQuestion: [],
        // clonedQuestion: [],

        // localeData: Config.localeData,
        dateRange: {
          startDate: null,
          endDate: null,
        },
        dateRangeOld: {
          startDate: null,
          endDate: null,
        },
        // dateProcessing: {
        //   startDate: null,
        //   endDate: null
        // },

        isSuperior: null,
        saleId: '',
        createdBy: '',
        dataStaff: [],

        error: {
          type: '',
          purposes: '',
          applyFor: '',
          merchantOwnerId: '',
          customerId: '',
          storeId: '',
          dateRange: '',
          assigneeId: '',
          afterSaleNote: '',
          newStatus: '',
          result: '',
          subCategoryCode: '',
          // dateProcessing: ''
        },
        typeSale,
        dataUser: JSON.parse(localStorage.getItem('userData')) || {},

        tLoadMerchantOwner: undefined,
        merchantOwnerSettings: {
          ajax: {
            transport: (params, success, failure) => {
              const txtSearch = params.data?.q?.trim() || ''
              if (!txtSearch) {
                return success({
                  results: [],
                })
              }

              // const queryString = txtSearch ? `{textSearch} LIKE '''${txtSearch}'''` : ''
              if (this.tLoadMerchantOwner) {
                clearTimeout(this.tLoadMerchantOwner)
              }
              this.tLoadMerchantOwner = setTimeout(() => {
                ListMo({
                  // showFields: ["id", "ownerName", "email"],
                  limit: 10,
                  page: 1,
                  // queryString,
                  keyWord: txtSearch,
                  sort: {
                    direction: 'ASC',
                    properties: ['ownerName'],
                  },
                })
                  .then(res => {
                    success({
                      results:
                        res.data.list?.map(item => {
                          return {
                            id: item.id,
                            text: item.ownerName || item.email,
                          }
                        }) || [],
                    })
                  })
                  .catch(failure)
              }, 500)
            },
          },
        },

        tLoadMerchant: undefined,
        merchantSettings: {
          ajax: {
            transport: (params, success, failure) => {
              const txtSearch = params.data?.q?.trim() || ''
              if (!txtSearch) {
                return success({
                  results: [],
                })
              }

              const queryString = txtSearch ? `{textSearch} LIKE '''${txtSearch}'''` : ''
              if (this.tLoadMerchant) {
                clearTimeout(this.tLoadMerchant)
              }
              this.tLoadMerchant = setTimeout(() => {
                ListMa({
                  showFields: ['id', 'accountName', 'email'],
                  limit: 10,
                  page: 1,
                  queryString,
                  sort: {
                    direction: 'ASC',
                    properties: ['accountName'],
                  },
                })
                  .then(res => {
                    success({
                      results: res.data.listData.map(item => {
                        return {
                          id: item.id,
                          text: item.accountName || item.email,
                        }
                      }),
                    })
                  })
                  .catch(failure)
              }, 500)
            },
          },
        },

        searchWork: {
          ajax: {
            delay: 500,
            transport: (params, success, failure) => {
              const txtSearch = params.data?.q?.trim() || ''
              if (!txtSearch) {
                return success({
                  results: [],
                })
              }
              const keySearch = txtSearch ?? ''
              if (this.tLoadOwner) {
                clearTimeout(this.tLoadOwner)
              }
              this.tLoadOwner = setTimeout(() => {
                CalendarAfsService.getWorkSubsection({
                  name: keySearch,
                  taskCode: this.purposesCode || '',
                  page: 1,
                  limit: 20,
                }) // AI
                  .then(res => {
                    success({
                      results:
                        res.data?.map(item => {
                          return {
                            id: item.code || '',
                            text: item.name || '',
                          }
                        }) || [],
                    })
                  })
                  .catch(failure)
              }, 500)
            },
          },
        },
      }
    },

    created() {
      this.id = this.$router.currentRoute.params.id || NEW_ID
    },

    async mounted() {
      await this.loadDataType()
      if (this.id && !this.isNew) {
        // await this.loadQuestionList()
        await this.loadData()
        await this.loadSubordinate()
        await this.checkUser()
      }
    },

    computed: {
      ...mapGetters({
        dataPermission: 'role/dataPermission',
      }),

      isUpdate() {
        return this.id && !this.isNew
      },

      canEdit() {
        return (
          this.isNew || // đang tạo task
          // this.dataPermission.includes('CNPS_CSS_TASK_UPDATE') && // có quyền cập nhật
          ([EnumTaskStatus.NEW, EnumTaskStatus.PROCESSING].includes(this.status) && // trạng thái là NEW || PROCESSING (Mới tạo, Đang xử lý)
            this.taskInfo?.saleId === currentUser?.userId) || // là người xử lý
          ([EnumTaskStatus.NEW].includes(this.status) && // trạng thái là NEW (Mới tạo)
            (this.taskInfo?.createdBy === currentUser?.userId || // người tạo
              this.dataStaff.some(item => item.id === currentUser?.userId))) // người quản lý của người xử lý
        )
      },

      canEditHandler() {
        return (
          this.isNew || // đang tạo task
          // this.dataPermission?.includes('CNPS_CSS_TASK_UPDATE') &&
          ([EnumTaskStatus.NEW].includes(this.status) && // trạng thái là NEW (Mới tạo)
            (this.dataPermission?.includes('CNPS_CSS_TASK_UPDATE_HANDLER') ||
              this.createdBy === this.currentUser?.userId)) // người tạo
        )
      },

      canEditTaskName() {
        return (
          this.isNew || // đang tạo task
          // this.dataPermission?.includes('CNPS_CSS_TASK_UPDATE') &&
          [EnumTaskStatus.NEW].includes(this.status) || // trạng thái là NEW (Mới tạo)
          ([EnumTaskStatus.PROCESSING].includes(this.status) && // trạng thái là NEW || PROCESSING (Mới tạo, Đang xử lý)
            this.saleId === this.currentUser?.userId) // là người xử lý
        )
      },

      hasShowAssignTaskButton() {
        return (
          this.dataPermission?.includes('CNPS_CSS_TASK_ASSIGN') && // có quyền assign
          (this.isNew || // đang tạo task
            [EnumTaskStatus.NEW, EnumTaskStatus.PROCESSING].includes(this.status)) // trạng thái là NEW || PROCESSING (Mới tạo, Đang xử lý)
        )
      },

      isNew() {
        return this.id === NEW_ID // || [EnumTaskStatus.NEW].includes(this.status)
      },

      isUpdateAndIsSuperior() {
        return this.id && !this.isNew && this.isSuperior
      },
      statusOptions() {
        return TaskStatus.map(s => {
          return {
            ...s,
            disabled: s.id !== this.status && !FlowChangeStatus[this.status]?.includes(s.id),
          }
        })
      },

      disabledStaff() {
        return (
          !this.applyFor ||
          (this.applyFor === EnumTaskApplyFor.MO
            ? !this.merchantOwnerId
            : this.applyFor === EnumTaskApplyFor.MA
              ? !this.customerId
              : !this.storeId) ||
          !this.staffOptions.length
        )
      },
      canChosseNoAssign() {
        return this.typeSale.includes(this.dataUser.typeSale)
      },

      listStaffOptions() {
        return [
          {
            id: '0',
            text: 'Không chọn nhân viên chăm sóc',
            disabled: this.canChosseNoAssign,
          },
          ...this.staffOptions,
        ]
      },
    },

    watch: {
      type: function (value) {
        this.hasSubmit && (this.error.type = !value ? 'Vui lòng chọn' : '')
      },
      methodCare: function (value) {
        this.hasSubmit && (this.error.methodCare = !value ? 'Vui lòng chọn' : '')
      },
      purposes: function (value) {
        this.hasSubmit && (this.error.purposes = !value ? 'Vui lòng chọn' : '')
      },
      applyFor: function (value) {
        this.hasSubmit && (this.error.applyFor = !value ? 'Vui lòng chọn' : '')
      },

      merchantOwnerId: function (value) {
        this.hasSubmit &&
          [EnumTaskApplyFor.MO].includes(this.applyFor) &&
          (this.error.merchantOwnerId = !value ? 'Vui lòng chọn' : '')
      },

      customerId: function (value) {
        this.hasSubmit &&
          [EnumTaskApplyFor.MA, EnumTaskApplyFor.STORE].includes(this.applyFor) &&
          (this.error.customerId = !value ? 'Vui lòng chọn' : '')
      },

      storeId: function (value) {
        this.hasSubmit &&
          [EnumTaskApplyFor.STORE].includes(this.applyFor) &&
          (this.error.storeId = !value ? 'Vui lòng chọn' : '')
      },

      assigneeId: function (value) {
        this.hasSubmit && (this.error.assigneeId = !value ? 'Vui lòng chọn' : '')
      },
      afterSaleNote: function (value) {
        this.hasSubmit &&
          (this.error.afterSaleNote = value.length > 255 ? 'Chiều dài tối đa 255 ký tự' : '')
      },

      // dateProcessing: function (value) {
      //   return (
      //     this.hasSubmit &&
      //     this.newStatus === EnumTaskStatus.FINISH &&
      //     (!value.startDate || !value.endDate ? 'Chiều dài tối đa 255 ký tự' : '')
      //   )
      // }
    },

    methods: {
      async changeCode(id) {
        const purposesCode = this.purposesOptions.find(item => item.id === id).code
        this.subCategoryCode = ''
        try {
          this.subCategoryCodeLoading = true

          const res = await CalendarAfsService.getWorkSubsection({
            taskCode: purposesCode || '',
            isActive: true,
            page: 1,
            limit: 100,
          })
          if (res.code === 1000) {
            this.subCategorypOtions =
              res.data?.map(item => {
                return {
                  id: item.code || '',
                  text: item.name || '',
                }
              }) || []
          }
        } catch (error) {
          console.error(error)
        } finally {
          this.subCategoryCodeLoading = false
        }
      },
      handleChoiceChange(ques) {
        if (!ques.choice) {
          ques.optionResult = []
          ques.otherAnswerResult = ''
          delete ques.optionResult
          delete ques.otherAnswerResult
        }
      },
      handleOptionChange(val, ques) {
        if (val.length) {
          if (!val.includes('OTHER')) {
            ques.otherAnswerResult = ''
            delete ques.otherAnswerResult
          }
        } else {
          ques.otherAnswerResult = ''
          delete ques.otherAnswerResult
        }
      },
      handleQuizChange(val, ques) {
        if (val.length > 1) {
          ques.optionResult = val.slice(-1)
        }
      },
      async loadData() {
        try {
          this.isLoading = true
          const res = await TaskDetail(this.id)
          if (res.result) {
            // if (res.data.collectionData) {
            //   const questionMap = res.data.collectionData.questionList?.reduce(
            //     (map, question) => {
            //       map[question?.questionCode] = question
            //       return map
            //     },
            //     {}
            //   )
            //   this.listQuestion?.forEach((question) => {
            //     const mappedQuestion = questionMap[question.questionCode]
            //     if (mappedQuestion) {
            //       question.choice = mappedQuestion.choice
            //       question.optionResult = mappedQuestion.optionResult
            //       question.otherAnswerResult = mappedQuestion.otherAnswerResult
            //     }
            //   })
            // }
            // this.clonedQuestion = _.cloneDeep(this.listQuestion)

            const taskInfo = res.data
            this.status = taskInfo.status
            this.newStatus = taskInfo.status
            this.methodCare = taskInfo.methodCare ?? EnumTaskMethodCare.OFFLINE
            this.saleId = taskInfo.saleId ?? ''
            // taskInfo.status === EnumTaskStatus.FINISH &&
            //   taskInfo.startProcessing &&
            //   taskInfo.endProcessing &&
            //   (() => {
            //     this.dateProcessing.startDate = new Date(taskInfo.startProcessing)
            //     this.dateProcessing.endDate = new Date(taskInfo.endProcessing)
            //   })()
            taskInfo.result &&
              (() => {
                this.result = taskInfo.result
                this.newResult = taskInfo.result
              })()
            taskInfo.afterSaleNote && (this.afterSaleNote = taskInfo.afterSaleNote)
            taskInfo.note && (this.note = taskInfo.note)
            taskInfo.description && (this.description = taskInfo.description)
            taskInfo.createdBy && (this.createdBy = taskInfo.createdBy)

            taskInfo.type &&
              (await (async () => {
                const option = this.typeOptions.find(t => t.code === taskInfo.type)
                option &&
                  (await (async () => {
                    this.type = option.id
                    await this.loadDataTask()
                    taskInfo.purposes?.length &&
                      (() => {
                        const option = this.purposesOptions.find(
                          t => t.code === taskInfo.purposes[0]
                        )
                        option && (this.purposes = option.id)
                      })()
                  })())
              })())

            taskInfo.startIntend &&
              taskInfo.endIntend &&
              (() => {
                this.dateRange.startDate = new Date(taskInfo.startIntend)
                this.dateRange.endDate = new Date(taskInfo.endIntend)

                this.dateRangeOld.startDate = new Date(taskInfo.startIntend)
                this.dateRangeOld.endDate = new Date(taskInfo.endIntend)
              })()

            this.images = taskInfo.images
            await this.changeCode(this.purposes)
            taskInfo.subCategoryCode && (this.subCategoryCode = taskInfo.subCategoryCode)
            // if (taskInfo.explanationImage?.length) {
            //   const formattedImages = taskInfo.explanationImage.map((imgObj) => ({
            //     url: imgObj.urlImage,
            //     location: imgObj.location,
            //     type: imgObj.type || 'images',
            //     uploaded: true
            //   }))
            //   nextTick(() => {
            //     this.$refs.uploadComponent?.setData(formattedImages)
            //   })
            // } else {
            //   nextTick(() => {
            //     this.$refs.uploadComponent?.setData([])
            //   })
            // }

            taskInfo.applyFor &&
              (await (async () => {
                this.applyFor = taskInfo.applyFor

                // set selected support info
                // taskInfo.methodCare !== EnumTaskMethodCare.OFFLINE && (async () => {
                //   await this.loadDataSupportInfo();
                // })();

                switch (taskInfo.applyFor) {
                  case EnumTaskApplyFor.MO:
                    taskInfo.merchantOwnerId &&
                      (await (async () => {
                        // set selected merchant owner | note: no remove this code
                        // load merchant owner info
                        // const resMoInfo = await GetMoByIds({
                        //   ids: taskInfo.merchantOwnerId,
                        // });
                        this.merchantOwnerOptions = [
                          {
                            id: taskInfo.merchantOwnerId,
                            text:
                              taskInfo.merchantOwnerInfo.ownerName ||
                              taskInfo.merchantOwnerInfo.email,
                          },
                        ]
                        this.merchantOwnerId = taskInfo.merchantOwnerId
                        // end set selected merchant owner

                        // set selected staff if allow edit | note: no remove this code
                        const resAssign = await this.loadStaffAssignData(
                          taskInfo.merchantOwnerId,
                          'MERCHANT_OWNER'
                        )
                        if (resAssign) {
                          this.staffOptions = resAssign
                        } else {
                          this.staffOptions = [
                            {
                              id: taskInfo.handlerRes.userId,
                              text: taskInfo.handlerRes.name || taskInfo.handlerRes.userName,
                            },
                          ]
                        }
                        this.assigneeId = taskInfo.handlerRes.userId ?? '0'

                        // set selected staff if not allow edit | note: no remove this code
                        // taskInfo.handlerRes?.userId &&
                        //   (() => {
                        //     this.staffOptions = [
                        //       {
                        //         id: taskInfo.handlerRes.userId,
                        //         text:
                        //           taskInfo.handlerRes.name ||
                        //           taskInfo.handlerRes.email,
                        //       },
                        //     ];
                        //     this.assigneeId = taskInfo.handlerRes.userId
                        //   })()
                      })())
                    break
                  case EnumTaskApplyFor.MA:
                    taskInfo.customerId &&
                      (await (async () => {
                        // set selected Marchant account
                        this.merchantOptions = [
                          {
                            id: taskInfo.customerId,
                            text:
                              taskInfo.customerInfoRes?.merchantName ||
                              taskInfo.customerInfoRes?.email,
                          },
                        ]
                        this.customerId = taskInfo.customerId

                        // set selected staff if allow edit | note: no remove this code
                        const resAssign = await this.loadStaffAssignData(
                          taskInfo.customerInfoRes.customerId,
                          'MERCHANT_ACCOUNT'
                        )
                        if (resAssign) {
                          this.staffOptions = resAssign
                        } else {
                          this.staffOptions = [
                            {
                              id: taskInfo.handlerRes.userId,
                              text: taskInfo.handlerRes.name || taskInfo.handlerRes.userName,
                            },
                          ]
                        }
                        this.assigneeId = taskInfo.handlerRes.userId ?? '0'

                        // set selected staff if not allow edit | note: no remove this code
                        // taskInfo.handlerRes?.userId &&
                        //   (() => {
                        //     this.staffOptions = [
                        //       {
                        //         id: taskInfo.handlerRes.userId,
                        //         text:
                        //           taskInfo.handlerRes.name ||
                        //           taskInfo.handlerRes.userName,
                        //       },
                        //     ];
                        //     this.assigneeId = taskInfo.handlerRes.userId
                        //   })()
                      })())
                    break
                  case EnumTaskApplyFor.STORE:
                    taskInfo.customerId &&
                      (await (async () => {
                        // set selected Marchant account
                        this.merchantOptions = [
                          {
                            id: taskInfo.customerId,
                            text:
                              taskInfo.customerInfoRes?.merchantName ||
                              taskInfo.customerInfoRes.email,
                          },
                        ]
                        this.customerId = taskInfo.customerId

                        // allow rechoise => load list store
                        // await this.loadDataStore()
                        // taskInfo.storeId && await (async () => {
                        //   this.storeId = taskInfo.storeId
                        //   // load list staff assign
                        //   await this.onChangeStore();
                        //   taskInfo.saleId && (this.assigneeId = taskInfo.saleId)
                        // })()
                        taskInfo.storeId &&
                          (() => {
                            this.storeOptions = [
                              {
                                id: taskInfo.storeId,
                                text: taskInfo.storeInfo.name || taskInfo.storeInfo.email,
                              },
                            ]

                            this.storeId = taskInfo.storeId
                          })()

                        // set selected staff if allow edit | note: no remove this code
                        const resAssign = await this.loadStaffAssignData(taskInfo.storeId, 'STORE')
                        if (resAssign) {
                          this.staffOptions = resAssign
                        } else {
                          this.staffOptions = [
                            {
                              id: taskInfo.handlerRes.userId,
                              text: taskInfo.handlerRes.name || taskInfo.handlerRes.userName,
                            },
                          ]
                        }
                        this.assigneeId = taskInfo.handlerRes.userId ?? '0'
                        // set selected staff if not allow edit | note: no remove this code
                        // taskInfo.handlerRes?.userId &&
                        //   (() => {
                        //     this.staffOptions = [
                        //       {
                        //         id: taskInfo.handlerRes.userId,
                        //         text:
                        //           taskInfo.handlerRes.name ||
                        //           taskInfo.handlerRes.userName,
                        //       },
                        //     ];
                        //     this.assigneeId = taskInfo.handlerRes.userId
                        //   })()
                      })())
                    break
                }

                // set selected support info
                // taskInfo.methodCare !== EnumTaskMethodCare.OFFLINE && (async () => {
                //   const mapSupportInfo =
                //     taskInfo.formDataList?.reduce((map, item) => {
                //       for (const task of item.taskInFormDataList) {
                //         map[`${task.formCode}|${task.taskInFormCode}`] = task
                //       }
                //       return map
                //     }, {}) || {}
                //   nextTick(() => {
                //     this.$refs.supportInfoRef?.setValues(mapSupportInfo)
                //   })
                // })();
              })())
          } else {
            showMess(this, 'Error', res.message, 'danger', 'b-toaster-top-right', 5 * 60 * 60)
          }
        } catch (e) {
          showMess(
            this,
            'Error',
            e.response?.data?.message || e.response?.message || e.message,
            'danger',
            'b-toaster-top-right',
            5 * 60 * 60
          )
        } finally {
          this.isLoading = false
        }
      },

      async loadSubordinate() {
        try {
          const res = await StaffService.getStaffByIdSuperior({
            userId: currentUser.userId,
          })
          if (res.code === 1000) {
            this.dataStaff =
              res.data?.map(s => ({
                id: s.userId,
                text: `${s.name} - ${s.userName}`,
              })) ?? []
          } else {
            showMess(this, 'Error', res.message, 'danger', 'b-toaster-top-right', 5 * 60 * 60)
          }
        } catch (e) {
          showMess(
            this,
            'Error',
            e.response?.data?.message || e.response?.message || e.message,
            'danger',
            'b-toaster-top-right',
            5 * 60 * 60
          )
        }
      },

      required(value) {
        return value ? true : 'This field is required'
      },

      async loadDataType() {
        try {
          const res = await WorkGroupList({
            size: 100,
            page: 1,
            status: 'APPLYING',
            applyFor: 'CV_CS',
          })
          if (res.result) {
            this.typeOptions = res.data.map(item => {
              return {
                id: item.id,
                text: item.groupName,
                code: item.groupCode,
              }
            })
          } else {
            showMess(this, 'Error', res.message, 'danger', 'b-toaster-top-right', 5 * 60 * 60)
          }
        } catch (e) {
          showMess(
            this,
            'Error',
            e.response?.data?.message || e.response?.message || e.message,
            'danger',
            'b-toaster-top-right',
            5 * 60 * 60
          )
        } finally {
          this.isLoading = false
        }
      },

      async loadDataTask() {
        try {
          this.isLoadingPurposes = true
          this.purposes = ''
          this.purposesOptions = []
          const res = await WorkTaskList({
            size: 100,
            page: 1,
            status: 'APPLYING',
            wkGroupId: this.type,
          })
          if (res.result) {
            this.purposesOptions = res.data.map(item => {
              return {
                id: item.id,
                text: item.taskName,
                code: item.taskCode,
              }
            })
          } else {
            showMess(this, 'Error', res.message, 'danger', 'b-toaster-top-right', 5 * 60 * 60)
          }
        } catch (e) {
          showMess(
            this,
            'Error',
            e.response?.data?.message || e.response?.message || e.message,
            'danger',
            'b-toaster-top-right',
            5 * 60 * 60
          )
        } finally {
          this.isLoadingPurposes = false
        }
      },

      // async loadDataMa() {
      //   try {
      //     this.purposes = "";
      //     this.purposesOptions = [];
      //     const res = await List({
      //       size: 100,
      //       page: 1,
      //       wkGroupId: this.type,
      //     });
      //     if (res.result) {
      //       this.purposesOptions = res.data.map((item) => {
      //         return {
      //           id: item.id,
      //           text: item.groupName,
      //         };
      //       });
      //     } else {
      //       showMess(
      //         this,
      //         "Error",
      //         res.message,
      //         "danger",
      //         "b-toaster-top-right",
      //         5 * 60 * 60
      //       );
      //     }
      //   } catch (e) {
      //     showMess(
      //       this,
      //       "Error",
      //       e.response?.data?.message || e.response?.message || e.message,
      //       "danger",
      //       "b-toaster-top-right",
      //       5 * 60 * 60
      //     );
      //   } finally {
      //     this.isLoading = false;
      //   }
      // },

      async onChangeSubject() {
        if (this.assignType === 'NORMAL') {
          this.assigneeId = ''
          this.staffOptions = []
        }
        this.storeId = ''
        this.storeOptions = []
        // await this.loadDataSupportInfo()
        switch (this.applyFor) {
          case EnumTaskApplyFor.MO:
            this.merchantOwnerId && this.loadStaffAssign(this.merchantOwnerId, 'MERCHANT_OWNER')
            break
          case EnumTaskApplyFor.MA:
            this.customerId && this.loadStaffAssign(this.customerId, 'MERCHANT_ACCOUNT')
            break
          case EnumTaskApplyFor.STORE:
            this.customerId && this.storeId && this.loadStaffAssign(this.storeId, 'STORE')
            this.customerId && this.loadDataStore()
            break
        }
      },

      async onChangeMerchantOwner() {
        if (this.assignType === 'NORMAL') {
          this.assigneeId = ''
          this.staffOptions = []
        }

        if (this.applyFor === EnumTaskApplyFor.MO) {
          this.loadStaffAssign(this.merchantOwnerId, 'MERCHANT_OWNER')
        }
      },

      async onChangeMerchant() {
        if (this.assignType === 'NORMAL') {
          this.assigneeId = ''
          this.staffOptions = []
        }
        await this.loadDataStore()
        if (this.applyFor === EnumTaskApplyFor.MA) {
          this.loadStaffAssign(this.customerId, 'MERCHANT_ACCOUNT')
        }
      },

      async onChangeStore() {
        if (this.assignType === 'NORMAL') {
          this.assigneeId = ''
          this.staffOptions = []
        }

        if (this.applyFor === EnumTaskApplyFor.STORE) {
          this.loadStaffAssign(this.storeId, 'STORE')
        }
      },

      async loadDataStore() {
        try {
          this.isLoadingStore = true
          this.storeId = ''
          this.storeOptions = []
          const res = await ListStore({
            size: 100,
            page: 1,
            queryString: `{mcAccountId} == '''${this.customerId}'''`,
          })
          if (res.result) {
            this.storeOptions = res.data.listData.map(item => {
              return {
                id: item.id,
                text: item.storeName,
              }
            })
          } else {
            showMess(this, 'Error', res.message, 'danger', 'b-toaster-top-right', 5 * 60 * 60)
          }
        } catch (e) {
          showMess(
            this,
            'Error',
            e.response?.data?.message || e.response?.message || e.message,
            'danger',
            'b-toaster-top-right',
            5 * 60 * 60
          )
        } finally {
          this.isLoadingStore = false
        }
      },

      async loadStaffAssignData(id, level) {
        try {
          this.isLoadingStaff = true
          const res = await GetAssignment({
            assignmentIds: [id],
            level: level,
          })
          if (res.result) {
            if (res.data?.length) {
              const list = []
              for (const assignInfo of res.data) {
                if (assignInfo.staffMain) {
                  list.push({
                    id: assignInfo.staffMain.staffId,
                    text: assignInfo.staffMain.staffName,
                  })
                }
                if (assignInfo.staffSeconds?.length) {
                  for (const staff of assignInfo.staffSeconds) {
                    if (staff.staffId && staff.staffName) {
                      list.push({
                        id: staff.staffId,
                        text: staff.staffName,
                      })
                    }
                  }
                }
              }
              return list
            }
          } else {
            showMess(this, 'Error', res.message, 'danger', 'b-toaster-top-right', 5 * 60 * 60)
            return undefined
          }
        } catch (e) {
          showMess(
            this,
            'Error',
            e.response?.data?.message || e.response?.message || e.message,
            'danger',
            'b-toaster-top-right',
            5 * 60 * 60
          )
          return undefined
        } finally {
          this.isLoadingStaff = false
        }
      },

      async loadStaffAssign(id, level) {
        try {
          this.isLoadingStaff = true
          if (this.assignType === 'NORMAL') {
            this.assigneeId = ''
            this.staffOptions = []
          }
          const res = await GetAssignment({
            assignmentIds: [id],
            level: level,
          })
          if (res.result) {
            if (res.data?.length) {
              const list = []
              let assignId = ''
              for (const assignInfo of res.data) {
                if (assignInfo.staffMain) {
                  // this.assigneeId = assignInfo.staffMain.staffId;
                  list.push({
                    id: assignInfo.staffMain.staffId,
                    text: assignInfo.staffMain.staffName,
                  })
                  assignId = assignInfo.staffMain.staffId
                }
                if (assignInfo.staffSeconds?.length) {
                  for (const staff of assignInfo.staffSeconds) {
                    if (staff.staffId && staff.staffName) {
                      list.push({
                        id: staff.staffId,
                        text: staff.staffName,
                      })

                      if (staff.staffId === currentUser.userId) {
                        assignId = currentUser.userId
                      }
                    }
                  }
                }
              }
              if (this.assignType === 'NORMAL') {
                this.staffOptions = list
                this.assigneeId = assignId
                this.memorizeStaff = { assigneeId: assignId, staffOptions: list }
              }
            } else {
              this.assigneeId = '0'
            }
          } else {
            showMess(this, 'Error', res.message, 'danger', 'b-toaster-top-right', 5 * 60 * 60)
          }
        } catch (e) {
          showMess(
            this,
            'Error',
            e.response?.data?.message || e.response?.message || e.message,
            'danger',
            'b-toaster-top-right',
            5 * 60 * 60
          )
        } finally {
          this.isLoadingStaff = false
        }
      },

      // async loadQuestionList() {
      //   try {
      //     const res = await QuestionList()
      //     this.listQuestion = res.data?.listData
      //   } catch (e) {
      //     this.showFailMx(
      //       e.response?.data?.message ? e.response.data.message : e.message
      //     )
      //   }
      // },

      // async loadDataSupportInfo() {
      //   if (!this.applyFor) return
      //   try {
      //     this.isLoadingSupportInfos = true
      //     const res = await WorkFormList({
      //       applyLevel: [EnumTaskApplyFor.MO, EnumTaskApplyFor.MA].includes(
      //         this.applyFor
      //       )
      //         ? 'MO_MA'
      //         : this.applyFor
      //     })
      //     if (res.result) {
      //       this.supportInfos = res.data?.listData || []
      //       nextTick(() => {
      //         this.$refs.supportInfoRef?.setData(res.data?.listData || [])
      //       })
      //     } else {
      //       showMess(
      //         this,
      //         'Error',
      //         res.message,
      //         'danger',
      //         'b-toaster-top-right',
      //         5 * 60 * 60
      //       )
      //     }
      //   } catch (e) {
      //     showMess(
      //       this,
      //       'Error',
      //       e.message,
      //       'danger',
      //       'b-toaster-top-right',
      //       5 * 60 * 60
      //     )
      //   } finally {
      //     this.isLoadingSupportInfos = false
      //   }
      // },

      validateForm() {
        let isSuccess = true

        for (const key in this.error) {
          this.error[key] = ''
        }

        if (!this.type) {
          this.error.type = 'Vui lòng chọn'
          isSuccess = false
        }

        if (!this.purposes) {
          this.error.purposes = 'Vui lòng chọn'
          isSuccess = false
        }

        if (!this.applyFor) {
          this.error.applyFor = 'Vui lòng chọn'
          isSuccess = false
        } else {
          if ([EnumTaskApplyFor.MO].includes(this.applyFor) && !this.merchantOwnerId) {
            this.error.merchantOwnerId = 'Vui lòng chọn'
            isSuccess = false
          }

          if (
            [EnumTaskApplyFor.MA, EnumTaskApplyFor.STORE].includes(this.applyFor) &&
            !this.customerId
          ) {
            this.error.customerId = 'Vui lòng chọn'
            isSuccess = false
          }

          if ([EnumTaskApplyFor.STORE].includes(this.applyFor) && !this.storeId) {
            this.error.storeId = 'Vui lòng chọn'
            isSuccess = false
          }
        }

        if (!this.assigneeId) {
          this.error.assigneeId = 'Vui lòng chọn'
          isSuccess = false
        }

        if (this.afterSaleNote.length > 255) {
          this.error.afterSaleNote = 'Chiều dài tối đa 255 ký tự'
          isSuccess = false
        }

        if (this.dateRange.startDate) {
          const startTime = this.dateRange.startDate.getTime()
          const now = Date.now()

          if (this.dateRangeOld.startDate) {
            const oldStartTime = this.dateRangeOld.startDate.getTime()
            if (oldStartTime > now) {
              if (startTime < now) {
                return showMess(
                  this,
                  'Error',
                  'Thời gian bắt đầu xử lý phải sau ngày hiện tại',
                  'danger',
                  'b-toaster-top-right',
                  5 * 60 * 60
                )
              }
            } else {
              if (startTime < oldStartTime) {
                return showMess(
                  this,
                  'Error',
                  'Thời gian bắt đầu xử lý phải sau ngày lưu trước đó',
                  'danger',
                  'b-toaster-top-right',
                  5 * 60 * 60
                )
              }
            }
          } else {
            if (startTime < now) {
              return showMess(
                this,
                'Error',
                'Thời gian bắt đầu xử lý phải sau ngày hiện tại',
                'danger',
                'b-toaster-top-right',
                5 * 60 * 60
              )
            }
          }

          if ((this.dateRange.endDate?.getTime() || 0) - startTime < 0) {
            return showMess(
              this,
              'Error',
              'Ngày kết thúc phải sau ngày bắt đầu',
              'danger',
              'b-toaster-top-right',
              5 * 60 * 60
            )
          }
        }

        // if (
        //   this.newStatus === EnumTaskStatus.FINISH &&
        //   (!this.dateProcessing.startDate || !this.dateProcessing.endDate)
        // ) {
        //   this.error.dateProcessing = 'Hãy nhập thời gian thực hiện công việc'
        // }

        return isSuccess
      },

      async submitForm() {
        this.hasSubmit = true

        // validate data
        if (!this.validateForm()) {
          // return showMess(
          //   this,
          //   'Error',
          //   'Hãy kiểm tra lại thông tin nhập',
          //   'danger',
          //   'b-toaster-top-right',
          //   5 * 60 * 60
          // )
          return
        }

        // save data
        // const formDataList = this.$refs.supportInfoRef?.getData()
        // const collectionData = {
        //   questionList: this.clonedQuestion
        // }

        try {
          this.isLoading = true

          // upload images and get it
          // const explanationImage = await this.$refs.uploadComponent.saveData()
          if (this.isUpdate) {
            // todo validate task require image
            const updateParam = {
              assignType: this.assignType,
              id: this.id,
              subCategoryCode: this.subCategoryCode,
              // explanationImage,
              // noteArr: [],
              // afterSaleNote: this.afterSaleNote,
              // type: this.type
              //   ? this.typeOptions.find((t) => t.id === this.type)?.code
              //   : '',
              // methodCare: this.methodCare ?? EnumTaskMethodCare.OFFLINE,
              purposes: this.purposes
                ? [this.purposesOptions.find(t => t.id === this.purposes)?.code]
                : [],
              // name: this.purposes
              //   ? this.purposesOptions.find((t) => t.id === this.purposes)?.text
              //   : '',
              // merchantOwnerId: this.merchantOwnerId,
              // customerId: this.customerId,
              // storeId: this.storeId,
              // customerName: null,
              saleId: this.assigneeId !== '0' ? this.assigneeId : '',
              note: this.note,
              subCategoryCode: this.subCategoryCode,
              description: this.description,
              startIntend: this.dateRange.startDate
                ? this.dateRange.startDate.getTime()
                : undefined,
              endIntend: this.dateRange.endDate ? this.dateRange.endDate.getTime() : undefined,
              // formDataList,
              // collectionData,
              // applyFor: this.applyFor
            }
            // if (
            //   this.status == EnumTaskStatus.NEW &&
            //   this.dataPermission &&
            //   this.dataPermission?.includes('CNPS_CSS_TASK_UPDATE')
            // ) {
            //   updateParam.action = 'MANAGER_UPDATE'
            // }
            this.status === EnumTaskStatus.NEW && (updateParam.action = 'MANAGER_UPDATE')

            const res = await TaskUpdate(this.id, updateParam)

            if (res.result) {
              // update status
              // if (
              //   this.result !== this.newResult ||
              //   this.status !== this.newStatus
              // ) {
              //   const bodySubmitStatus = {
              //     status: this.newStatus,
              //     result: this.newResult || undefined
              //   }
              //   if (
              //     this.newStatus === EnumTaskStatus.FINISH &&
              //     this.dateProcessing.startDate &&
              //     this.dateProcessing.endDate
              //   ) {
              //     bodySubmitStatus.startProcessing =
              //       this.dateProcessing.startDate.getTime()
              //     bodySubmitStatus.endProcessing =
              //       this.dateProcessing.endDate.getTime()
              //   }
              //   const resStatus = await TaskUpdateStatus(
              //     this.id,
              //     bodySubmitStatus
              //   )
              //   if (resStatus.result) {
              //     this.showSuccessMx('Cập nhật thành công').then(() => {
              //       this.loadData()
              //     })
              //   } else {
              //     this.showFailMx(
              //       `Cập nhật trạng thái: ${resStatus.data?.message || resStatus.message}`
              //     )
              //   }
              // } else {
              //   this.showSuccessMx('Cập nhật thành công').then(() => {
              //     this.loadData()
              //   })
              // }
              this.showSuccessMx('Cập nhật thành công').then(() => {
                this.loadData()
              })
            } else {
              this.showFailMx(`Cập nhật thông tin: ${res.data?.message || res.message}`)
            }
          } else {
            const res = await TaskAdd({
              assignType: this.assignType,
              // explanationImage,
              noteArr: [],
              afterSaleNote: this.afterSaleNote,
              type: this.type ? this.typeOptions.find(t => t.id === this.type)?.code : '',
              methodCare: this.methodCare ?? EnumTaskMethodCare.OFFLINE,
              purposes: this.purposes
                ? [this.purposesOptions.find(t => t.id === this.purposes)?.code]
                : [],
              name: this.purposes
                ? this.purposesOptions.find(t => t.id === this.purposes)?.text
                : '',
              merchantOwnerId: this.merchantOwnerId,
              customerId: this.customerId,
              storeId: this.storeId,
              customerName: null,
              saleId: this.assigneeId !== '0' ? this.assigneeId : '',
              note: this.note,
              description: this.description,
              startIntend: this.dateRange.startDate
                ? this.dateRange.startDate.getTime()
                : undefined,
              endIntend: this.dateRange.endDate ? this.dateRange.endDate.getTime() : undefined,
              // formDataList,
              applyFor: this.applyFor,
              subCategoryCode: this.subCategoryCode,
            })
            if (res.result) {
              this.showSuccessMx('Thêm mới thành công').then(() => {
                this.$router.push(`/customer-support/task/`)
              })
            } else {
              this.showFailMx(res.data?.message || res.message)
            }
          }
        } catch (e) {
          showMess(
            this,
            'Error',
            e.response?.data?.message || e.response?.message || e.message,
            'danger',
            'b-toaster-top-right',
            5 * 60 * 60
          )
        } finally {
          this.isLoading = false
        }
      },

      async checkUser() {
        // const userData = JSON.parse(localStorage.getItem('userData'))
        const response = await StaffService.getStaffById({
          userId: this.assigneeId,
        })
        if (response.success && response.data) {
          const dataUser = response.data
          if (dataUser.superior || dataUser.superiorId || dataUser.superiorName) {
            if (dataUser.superior && dataUser.superior == this.currentUser.username) {
              this.isSuperior = true
            } else if (dataUser.superiorId && dataUser.superiorId == this.currentUser.userId) {
              this.isSuperior = true
            } else if (dataUser.superiorName && dataUser.superiorName == this.currentUser.name) {
              this.isSuperior = true
            } else {
              this.isSuperior = false
            }
          } else {
            this.isSuperior = true
          }
        }
      },

      showPopupFindStaff() {
        if (this.$refs.popupFindStaffRef) {
          this.$refs.popupFindStaffRef.show()
        }
      },
      onChangeStaff(data) {
        this.assignType = data.objectType
        this.assigneeId = data.staffSelected.id
        this.staffOptions = [data.staffSelected]
      },
      RemoveAssignTask() {
        this.assignType = 'NORMAL'
        console.log('this.memorizeStaff', this.memorizeStaff)
        this.assigneeId = this.memorizeStaff?.assigneeId || ''
        this.staffOptions = this.memorizeStaff?.staffOptions || []
      },
    },
  }
</script>

<style scoped lang="scss">
  .card-section {
    width: 100%;
    -webkit-box-shadow: 1px 2px 6px rgba(0, 0, 0, 0.2);
    box-shadow: 1px 2px 6px rgba(0, 0, 0, 0.2);
    border-radius: 10px;

    .header-section {
      font-weight: 600;
      font-size: 16px;
      line-height: 24px;
      position: relative;
      margin-left: 10px;

      &::before {
        content: ' ';
        position: absolute;
        width: 4px;
        height: 24px;
        background: #13569f;
        left: -10px;
      }
    }

    .form-item {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-top: 12px;

      &:first-child {
        margin-top: 0;
      }

      .form-label {
        font-weight: 400;
        font-size: 14px;
        color: #2a2a2a;
        //max-width: 150px;

        &.require::after {
          content: '*';
          color: #f00;
          margin-left: 4px;
        }
      }

      .form-input {
        width: 60%;

        .error {
          color: #f00;
        }
      }
    }
  }

  .no-data {
    width: 100%;
    color: #999;
    border: 1px solid #ddd;
    height: 60px;
    align-items: center;
    border-radius: 5px;
    display: flex;
    justify-content: center;
  }

  .question-code {
    font-size: 14px;
    text-transform: uppercase;
    font-weight: 500;
    color: black;
  }

  ::v-deep(.custom-control-label) {
    line-height: 24px;
  }

  .form-quescard {
    margin-bottom: 5px !important;
  }

  .collapse {
    &.show {
      .question-card {
        border-bottom: 1px solid #ddd;
      }
    }
  }

  .question-border {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding-right: 5px;
    width: 100%;

    &.collapsed {
      border-bottom: 1px solid #ddd;
    }

    &:hover {
      background-color: #eee;
    }
  }

  .not-collapsed {
    .question-code {
      padding: 10px;
    }

    &::after {
      content: '▲';
      font-size: 16px;
      color: #999;
      margin-left: 5px;
    }
  }

  .collapsed {
    .question-code {
      padding: 10px;
    }

    &::after {
      content: '▼';
      font-size: 16px;
      color: #999;
      margin-left: 5px;
    }
  }
</style>
